import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  class: "text-base font-semibold text-slate-900"
};
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_5 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_6 = {
  class: "relative"
};
const _hoisted_7 = {
  class: "mt-4 space-y-1"
};
const _hoisted_8 = {
  key: 2,
  class: "rounded-lg border border-dashed border-slate-200 p-4 text-center text-xs text-slate-500"
};
import { ref, computed } from 'vue';
import KbCategoryTreeNode from './KbCategoryTreeNode.vue';
export default {
  __name: 'KbCategoryTree',
  props: {
    tree: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    title: {
      type: String,
      default: '分类管理'
    },
    description: {
      type: String,
      default: ''
    },
    showAdd: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    }
  },
  emits: ['add', 'edit', 'delete', 'select', 'add-child'],
  setup(__props) {
    const props = __props;
    const filterText = ref('');
    const expandedIds = ref(new Set());
    const toggleExpand = id => {
      if (expandedIds.value.has(id)) {
        expandedIds.value.delete(id);
      } else {
        expandedIds.value.add(id);
      }
    };
    const filterTree = (nodes, text) => {
      if (!text) return nodes;
      const lower = text.toLowerCase();
      return nodes.reduce((acc, node) => {
        const nameMatch = node.name?.toLowerCase().includes(lower);
        const filteredChildren = node.children ? filterTree(node.children, text) : [];
        if (nameMatch || filteredChildren.length) {
          acc.push({
            ...node,
            children: filteredChildren.length ? filteredChildren : node.children
          });
          if (filteredChildren.length) {
            expandedIds.value.add(node.id);
          }
        }
        return acc;
      }, []);
    };
    const filteredTree = computed(() => filterTree(props.tree, filterText.value));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1), __props.showAdd ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('add')),
        class: "rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
      }, " 新增分类 ")) : _createCommentVNode("", true)]), __props.description ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1)) : _createCommentVNode("", true), __props.showSearch ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filterText.value = $event),
        type: "text",
        placeholder: "搜索分类...",
        class: "w-full rounded-lg border border-slate-200 bg-white py-1.5 pl-8 pr-3 text-xs text-slate-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
      }, null, 512), [[_vModelText, filterText.value]]), _cache[4] || (_cache[4] = _createElementVNode("svg", {
        class: "absolute left-2.5 top-2 h-3.5 w-3.5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })], -1))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('select', null)),
        class: _normalizeClass(['flex cursor-pointer items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition', __props.selectedId === null ? 'bg-primary-50 font-medium text-primary-700' : 'text-slate-600 hover:bg-slate-50'])
      }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
        class: "h-4 w-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 6h16M4 10h16M4 14h16M4 18h16"
      })], -1), _createElementVNode("span", null, "全部分类", -1)]))], 2), __props.loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(4, n => {
        return _createElementVNode("div", {
          key: n,
          class: "animate-pulse rounded-lg bg-slate-50 px-3 py-3"
        }, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "h-3.5 w-20 rounded bg-slate-200"
        }, null, -1)]))]);
      }), 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(filteredTree.value, node => {
        return _openBlock(), _createBlock(KbCategoryTreeNode, {
          key: node.id,
          node: node,
          depth: 0,
          "selected-id": __props.selectedId,
          "expanded-ids": expandedIds.value,
          "show-actions": __props.showActions,
          onSelect: _cache[3] || (_cache[3] = id => _ctx.$emit('select', id)),
          onToggle: toggleExpand,
          onEdit: node => _ctx.$emit('edit', node),
          onDelete: node => _ctx.$emit('delete', node),
          onAddChild: node => _ctx.$emit('add-child', node)
        }, null, 8, ["node", "selected-id", "expanded-ids", "show-actions", "onEdit", "onDelete", "onAddChild"]);
      }), 128)), !__props.loading && !filteredTree.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无分类数据 ")) : _createCommentVNode("", true)])]);
    };
  }
};